// ----------------------------------------------------------------------

export default function Input(theme) {
  const isDark = theme.palette.mode === "dark";

  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          backgroundColor: isDark
            ? "rgba(102, 133, 255, 0.05)"
            : "rgba(8, 145, 178, 0.06)",
          transition: theme.transitions.create([
            "border-color",
            "background-color",
            "box-shadow",
          ]),
          "& fieldset": {
            borderColor: isDark
              ? "rgba(102, 133, 255, 0.2)"
              : "rgba(8, 145, 178, 0.3)",
            transition: "all 0.3s",
          },
          "&:hover fieldset": {
            borderColor: isDark
              ? "rgba(102, 133, 255, 0.5) !important"
              : "rgba(8, 145, 178, 0.6) !important",
          },
          "&.Mui-focused fieldset": {
            borderColor: isDark
              ? "rgba(102, 133, 255, 0.8) !important"
              : "rgba(8, 145, 178, 0.9) !important",
            boxShadow: isDark
              ? "0 0 10px rgba(102, 133, 255, 0.2)"
              : "0 0 10px rgba(8, 145, 178, 0.15)",
          },
          "& .MuiSvgIcon-root": {
            color: isDark
              ? "rgba(102, 133, 255, 0.8)"
              : "rgba(8, 145, 178, 0.8)",
          },
        },
        input: {
          padding: "16.5px 14px", // Default MUI padding, but can be adjusted
          color: isDark ? "#e2e8f0" : "#0f172a",
          fontFamily: "var(--tw-)",
          "&::placeholder": {
            color: isDark ? "rgba(148,163,184,0.7)" : "rgba(71,85,105,0.6)",
            opacity: 1,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: isDark ? "rgba(148,163,184,0.7)" : "rgba(71,85,105,0.6)",
          "&.Mui-focused": {
            color: isDark
              ? "rgba(102, 133, 255, 0.8)"
              : "rgba(8, 145, 178, 0.9)",
          },
        },
      },
    },
  };
}
